import { GrossMarginValues, GrossMarginResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Gross margin % = Gross profit / Sales * 100
export function calculateGrossMargin(values: GrossMarginValues, t?: ToolsTranslations['grossMargin']): GrossMarginResult {
  const { grossProfit, sales } = values;
  if (grossProfit < 0) return { percent: null, isValid: false, message: t?.invalid.grossProfit };
  if (sales <= 0) return { percent: null, isValid: false, message: t?.invalid.sales };

  const percent = Math.round((grossProfit / sales) * 100);
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };
  return { percent, isValid: true };
}


